import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { environment } from "../../../../../environments/environment";

@Component({
    standalone: false,
    selector: 'app-web-chat-side', 
    templateUrl: './web-chat-side.component.html',
    styleUrls: ['./web-chat-side.component.scss']
})
export class WebChatSideComponent { 
  @Input() orderNumber: string;
  @Input() orderState: string;
  @Input() chatToken: string;
  @Input() companyCode: string;
  @Output() close = new EventEmitter<void>();

  iframeUrl!: SafeResourceUrl;

  isModalOpen = false;
  modalImageUrl: string = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges() {
    if (this.orderNumber && this.companyCode && this.chatToken && this.orderState) {
      
      const isLogged = localStorage.getItem(environment.sessionAuth)
      let userSession = isLogged ? `${JSON.parse(isLogged).user.name} ${JSON.parse(isLogged).user.lastName}`.trim() : '';

      let url = `${environment.webChatUrl}/${this.orderNumber}/${this.companyCode}/${this.chatToken}/${this.orderState}`;

      if (userSession) {
        url += `?userSession=${encodeURIComponent(userSession)}`;
      }

      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  ngOnInit() {
    window.addEventListener('message', this.handleIframeMessage);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleIframeMessage);
  }

  private handleIframeMessage = (event: MessageEvent) => {
    if (event.data.type === 'chat-image-clicked') {
      this.openImageModal(event.data.url);
    }
  }

  openImageModal(url: string) {
    this.modalImageUrl = url;
    this.isModalOpen = true;
    document.body.classList.add('modal-open');
  }

  closeImageModal() {
    this.modalImageUrl = '';
    this.isModalOpen = false;
    document.body.classList.remove('modal-open');
  }

}